import { Trans } from '@lingui/react'
import { type VFC } from 'react'

import IconProfile from 'views/components/atoms/Icon/IconProfile'
import Item from 'views/components/organisms/CmsMobileMenu/Item'
import { type AuthHeaderProps } from 'views/components/organisms/CmsMobileMenu/types'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import './AuthHeader.scss'

const AuthHeader: VFC<AuthHeaderProps> = ({ mountPoints, userLoggedIn }) => {
  return (
    <ul className="a-list-reset">
      {userLoggedIn ? (
        <li
          className="o-AuthHeader__item"
          data-qa-id="m-inside-hamburger-logged-in"
        >
          <Item
            href={mountPoints.getUserAccount()}
            name="off-canvas-login"
            className="o-AuthHeader__text__wrapper"
          >
            <IconProfile className="o-AuthHeader__icon" />
            <Trans id="offcanvas.link.myApotheke" />
          </Item>
        </li>
      ) : (
        <li
          className="o-AuthHeader__item"
          data-qa-id="m-inside-hamburger-not-logged-in"
        >
          <Item
            href={mountPoints.getLogin()}
            name="off-canvas-login"
            className="o-AuthHeader__text__wrapper"
          >
            <IconProfile className="o-AuthHeader__icon" />
            <Trans id="offcanvas.link.loginOrRegister" />
          </Item>
        </li>
      )}
    </ul>
  )
}

export default withMountPoints(withShopAndRuntimeConfig(AuthHeader))
